
    import __i18nConfig from '@next-translate-root/i18n.js'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import { Meta, Stepper } from "@/components/core";
import { SignInEntrance, SignUpConfirm } from "@/modules/register/index";
import { AccountEntranceLayout } from "@/components/layout/account-entrance";
export default function RegisterPage() {
    return (<AccountEntranceLayout>
      <Meta title="UPTION Tüzel Web Şube - Register"/>
      <Stepper hideStepLabels>
        <Stepper.Step key="sign-up-entrance">
          <SignInEntrance />
        </Stepper.Step>
        <Stepper.Step key="sign-up-confirm">
          <SignUpConfirm />
        </Stepper.Step>
      </Stepper>
    </AccountEntranceLayout>);
}

    async function __Next_Translate__getStaticProps__1a16af5a8c9__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/register/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a16af5a8c9__ as getStaticProps }
  